import React from "react";
import { useHistory } from "react-router-dom";
import { LoginComponent } from "@frontrunners/wl-cognito-login";
import { SsciamLoginComponent } from "./ssciam/SscIamLoginComponent";
import { LAST_USED_LOGIN_EMAIL, setCognitoTokens, ssciamIsEnabled } from "../common/authHelper";

const supportalLocale = "en"; // We always want supportal to just be in english

export const getPoolData = (store) => {
  const state = store.getState();
  const config = state.getIn(["config", "endpoints"]);

  const poolData = {
    UserPoolId: config.cognitoUserPoolId,
    ClientId: config.cognitoSupportalClientId,
  };

  return poolData;
};

export const LoginContainer = ({ store }) => {
  const history = useHistory();
  const poolData = getPoolData(store);
  const storeEmail = window.localStorage.getItem(LAST_USED_LOGIN_EMAIL) || "";

  const onSuccessCallback = (result, username) => {
    const idToken = result?.idToken?.jwtToken;

    if (idToken) {
      setCognitoTokens(idToken, username);
    }

    // Navigate to dashboard using React Router
    history.push("/");
  };

  const enableSscIam = ssciamIsEnabled();

  return (
    <div style={{ height: "100vh" }}>
      {enableSscIam ? (
        <SsciamLoginComponent defaultEmail={storeEmail} />
      ) : (
        <LoginComponent
          locale={supportalLocale}
          poolData={poolData}
          onSuccessCallback={onSuccessCallback}
          resetPasswordRoute="https://reports.bambora.com/reset-password"
          setPasswordRoute="/not-supported"
          applicationName={"Supportal"}
        />
      )}
    </div>
  );
};
